import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj["default"] = "bright";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "white";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "lightGrey";
  obj["default"] = "bright";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createBasicTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_DARKBLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "darkblue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "lightblue";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "baseGrey";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "baseGrey";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "baseGrey";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "orange";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_TURQUOISE"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createBulletListDeprecatedMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "green";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_DARKBLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "darkblue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "lightblue";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "whiteOutline";
  obj[AllColors["COLOR_TEAL"]] = "whiteOutline";
  obj[AllColors["COLOR_TURQUOISE"]] = "whiteOutline";
  obj[AllColors["COLOR_ORANGE"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "green";
  obj[AllColors["COLOR_GREEN"]] = "blue";
  obj["default"] = "blue";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blueActive";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blueActive";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "Bright";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj["default"] = "bright";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "blueInverted";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_GREEN"]] = "greenInverted";
  obj[AllColors["COLOR_TEAL"]] = "tealInverted";
  obj[AllColors["COLOR_ORANGE"]] = "orangeInverted";
  obj["default"] = "blue";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "inverted";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "inverted";
  obj[AllColors["COLOR_ORANGE"]] = "inverted";
  obj[AllColors["COLOR_TEAL"]] = "inverted";
  obj["default"] = "blue";
  return obj;
}
export function createChipMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "green";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "blue";
  obj[AllColors["COLOR_ORANGE"]] = "blue";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "green";
  obj["default"] = "green";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj["default"] = "blue";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj["default"] = "blue";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "whiteOnBlue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "whiteOnGreen";
  obj[AllColors["COLOR_TEAL"]] = "whiteOnTeal";
  obj[AllColors["COLOR_ORANGE"]] = "whiteOnOrange";
  obj["default"] = "blue";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "dark";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "dark";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "whiteOnBlue";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj["default"] = "blue";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "white";
  obj["default"] = "standard";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_DARK"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_TURQUOISE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createHeadlineBrandMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createHeroSectionMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createHighlightBannerMapDefinition() {
  let obj = {};
  obj["default"] = "blue";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj["default"] = "blue";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_DARK"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_BLUE_ACTIVE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj["default"] = "blue";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj["default"] = "lightblue";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "lightGrey";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "blue";
  obj[AllColors["COLOR_ORANGE"]] = "blue";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "lightGrey";
  return obj;
}
export function createOffsetTeaser5MapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "lightblue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "lightgreen";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "lightorange";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj[AllColors["COLOR_TURQUOISE"]] = "turquoise";
  obj["default"] = "lightGrey";
  return obj;
}
export function createOptionPickerItemMapDefinition() {
  let obj = {};
  obj["default"] = "green";
  return obj;
}
export function createPaginationMapDefinition() {
  let obj = {};
  obj["default"] = "blue";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "colorful";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "colorful";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "colorful";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "green";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "orange";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "green";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "orange";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj["default"] = "blue";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "lightGrey";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_BLUE_ACTIVE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "blue";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "inverted";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "green";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "orange";
  obj[AllColors["COLOR_GREEN"]] = "inverted";
  obj[AllColors["COLOR_ORANGE"]] = "inverted";
  obj[AllColors["COLOR_TEAL"]] = "inverted";
  obj["default"] = "blue";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "darkOnBright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "darkOnBright";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "darkOnBright";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "darkOnBright";
  obj[AllColors["COLOR_BLUE"]] = "brightOnBlue";
  obj[AllColors["COLOR_GREEN"]] = "brightOnGreen";
  obj[AllColors["COLOR_ORANGE"]] = "brightOnOrange";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj["default"] = "darkOnBright";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARK"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "blue";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "blue";
  obj[AllColors["COLOR_BLUE_ACTIVE"]] = "bright";
  obj[AllColors["COLOR_GREEN_ACTIVE"]] = "dark";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj["default"] = "dark";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj["default"] = "bright";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "lightGrey";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "brightWithLightGreyDescription";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "bright";
  obj[AllColors["COLOR_ORANGE"]] = "bright";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "lightGrey";
  return obj;
}
export function createSegmentedButtonMapDefinition() {
  let obj = {};
  obj["default"] = "dark";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "brightBlue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "brightOnLightGrey";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "brightBlue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "brightBlue";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "brightBlue";
  obj["default"] = "Brightblue";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "brightOnBlue";
  obj[AllColors["COLOR_GREEN"]] = "brightOnGreen";
  obj[AllColors["COLOR_ORANGE"]] = "brightOnOrange";
  obj["default"] = "blue";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "inverted";
  obj[AllColors["COLOR_GREEN"]] = "inverted";
  obj[AllColors["COLOR_ORANGE"]] = "inverted";
  obj[AllColors["COLOR_TEAL"]] = "inverted";
  obj["default"] = "blue";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createStatePillMapDefinition() {
  let obj = {};
  obj["default"] = "active";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blueOnLightGrey";
  obj[AllColors["COLOR_BLUE"]] = "brightOnBlue";
  obj[AllColors["COLOR_GREEN"]] = "brightOnGreen";
  obj[AllColors["COLOR_ORANGE"]] = "brightOnOrange";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj["default"] = "blue";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "blue";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blueOnLightGrey";
  obj[AllColors["COLOR_BLUE"]] = "brightOnBlue";
  obj[AllColors["COLOR_GREEN"]] = "brightOnGreen";
  obj[AllColors["COLOR_ORANGE"]] = "brightOnOrange";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj["default"] = "blue";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "brightBlueHighlighting";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "lightGreyBlueHighlighting";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj["default"] = "brightBlueHighlighting";
  return obj;
}
export function createTabNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "lightGrey";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blueOnLightblue";
  obj[AllColors["COLOR_LIGHTGREEN"]] = "greenOnLightgreen";
  obj[AllColors["COLOR_LIGHTORANGE"]] = "orangeOnLightorange";
  obj["default"] = "bright";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_TEAL"]] = "teal";
  obj["default"] = "bright";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "green";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "blue";
  obj[AllColors["COLOR_BLUE"]] = "brightOnBlue";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "blueOnLightblue";
  obj[AllColors["COLOR_GREEN"]] = "brightOnGreen";
  obj[AllColors["COLOR_ORANGE"]] = "brightOnOrange";
  obj[AllColors["COLOR_TEAL"]] = "brightOnTeal";
  obj[AllColors["COLOR_LIGHTBLUE"]] = "green";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "dark";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "dark";
  obj[AllColors["COLOR_ORANGE"]] = "dark";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "lightGrey";
  obj[AllColors["COLOR_LIGHT_GREY"]] = "bright";
  obj[AllColors["COLOR_BLUE"]] = "bright";
  obj[AllColors["COLOR_GREEN"]] = "lightGrey";
  obj[AllColors["COLOR_ORANGE"]] = "lightGrey";
  obj[AllColors["COLOR_TEAL"]] = "bright";
  obj["default"] = "lightGrey";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_LIGHT_GREY"]] = "lightGrey";
  obj[AllColors["COLOR_BLUE"]] = "blue";
  obj[AllColors["COLOR_GREEN"]] = "green";
  obj[AllColors["COLOR_ORANGE"]] = "orange";
  obj["default"] = "lightGrey";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj["default"] = "blue";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj["default"] = "dark";
  return obj;
}
export function createWebsiteNavigationMapDefinition() {
  let obj = {};
  return obj;
}
